"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProCon = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _offerStyles = require("../common/offer-styles");

var _detailsTabs = require("../common/details-tabs");

var _jsxRuntime = require("react/jsx-runtime");

var ProConWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ProConWrapper",
  componentId: "sc-1duzft0-0"
})(["display:grid;grid-template-columns:1fr;grid-gap:24px;padding:24px 0;@media (", "){grid-template-columns:1fr 1fr;}"], _baseReactComponents.theme.forLargerThanPhone);

var ProCon = function ProCon(_ref) {
  var _loanOffer$navEditori, _loanOffer$navEditori2, _loanOffer$navEditori3, _loanOffer$navEditori4;

  var loanOffer = _ref.loanOffer,
      shownTab = _ref.shownTab,
      handleShownTab = _ref.handleShownTab;
  var title = 'Pros and Cons';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_detailsTabs.MobileTab, {
      shownTab: shownTab,
      title: title,
      handleShownTab: handleShownTab
    }), shownTab === title && /*#__PURE__*/(0, _jsxRuntime.jsxs)(ProConWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.WithIconWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
          name: "actions/circle-plus",
          color: _baseReactComponents.theme.seaturtleGreen200
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
            bold: true,
            children: "Pros"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
            color: "light",
            children: (_loanOffer$navEditori = (_loanOffer$navEditori2 = loanOffer.navEditorial) === null || _loanOffer$navEditori2 === void 0 ? void 0 : _loanOffer$navEditori2.pros) !== null && _loanOffer$navEditori !== void 0 ? _loanOffer$navEditori : ''
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.WithIconWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
          name: "actions/circle-minus",
          color: _baseReactComponents.theme.sebastianRed200
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
            bold: true,
            children: "Cons"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
            color: "light",
            children: (_loanOffer$navEditori3 = (_loanOffer$navEditori4 = loanOffer.navEditorial) === null || _loanOffer$navEditori4 === void 0 ? void 0 : _loanOffer$navEditori4.cons) !== null && _loanOffer$navEditori3 !== void 0 ? _loanOffer$navEditori3 : ''
          })]
        })]
      })]
    })]
  });
};

exports.ProCon = ProCon;
//# sourceMappingURL=pro-con.js.map